import { debounce } from "lodash";
import dateComparator from "./dateComparator";
import AntdDateFilter from "../components/AgGridWrapper/AntdDateFilter";
import AntdDateFloatingFilter from "../components/AgGridWrapper/AntdDateFloatingFilter";
export const renderNA = (data: any) => {
  return data ? data : "N/A";
};

export const validateFields = debounce((form, setDisabled) => {
  form
    .validateFields()
    .then(() => {
      setDisabled(false);
    })
    .catch(() => {
      setDisabled(true);
    });
}, 500);

export const toUpperCaseWithUnderscore = (inputString: string) => {
  if (inputString && typeof inputString === "string") {
    const words = inputString.split(" ").map((word) => word.toUpperCase());
    return words.join("_");
  }
};

export const toLowerCaseWithUnderscore = (inputString: string) => {
  if (inputString && typeof inputString === "string") {
    const words = inputString.split(" ").map((word) => word.toLowerCase());
    return words.join("_");
  } else {
    return "";
  }
};

export const generateColumn = (headerName?: string, fieldName?: any) => {
  const field = fieldName || toLowerCaseWithUnderscore(headerName || "");
  return {
    field: field,
    // headerName: headerName || (Object.hasOwn(fieldName,'toTitleCase') ?  fieldName.toTitleCase() :fieldName),
    headerName: headerName || fieldName.toTitleCase(),

    cellRenderer: (props: any) => {
      return renderNA(props.data?.[field]);
    },
    filterValueGetter: (props: any) => {
      return renderNA(props.data?.[field]);
    },
    valueGetter: (props: any) => {
      return renderNA(props.data?.[field]);
    },
  };
};

export const generateImportColumn = (
  headerName?: string,
  fieldName?: any
) => {
  const field = fieldName || toLowerCaseWithUnderscore(headerName || "");
  return {
    field: field,
    headerName: headerName || fieldName?.toTitleCase(),
    cellRenderer: (props: any) => {
      return props.data?.[field];
    },
  };
};

export const setFilterDefs = (values: any) => {
  return {
    filter: "agSetColumnFilter",
    filterParams: {
      values: values,
      buttons: ["apply", "reset"],
      closeOnApply: true,
    },
  };
};
// export const setDateFilterDefs = () => {
//   return {
//     filter: "agDateColumnFilter",
//     filterParams: {
//       buttons: ["apply", "reset"],
//       inRangeInclusive: true,
//       suppressAndOrCondition: true,
//       comparator: dateComparator,
//       browserDatePicker: true,
//     },
//   };
// };
export const setDateFilterDefs = () => {
  return {
    // filter: AntdDateFilter as any,
    floatingFilter: true,
    floatingFilterComponent: AntdDateFloatingFilter as any,
    // filter: "agDateColumnFilter",
    // filterParams: {
    //   buttons: ["apply", "reset"],
    //   inRangeInclusive: true,
    //   suppressAndOrCondition: true,
    //   comparator: dateComparator,
    //   browserDatePicker: true,
    // },
  };
};

export const formatMobileNumber = (str: any) => {
  const cleanedValue = str.replace(/[^\d]/g, "");

  // Format the cleaned value as "###-###-####."
  const formattedValue = cleanedValue.replace(
    /(\d{3})(\d{3})(\d{4})/,
    "$1-$2-$3"
  );
  return formattedValue;
};

export const importErrorFunction = () => {
  return {
    tooltipValueGetter: (params: any) => {
      if (
        params.data.errors &&
        Object.hasOwn(params.data.errors, params.colDef.field)
      ) {
        return params?.data?.errors[params.colDef.field]?.toString();
      } else {
        return params.value;
      }
    },
    cellStyle: (params: any) => {
      if (
        params.data.errors &&
        Object.hasOwn(params.data.errors, params.colDef.field)
      ) {
        return { color: "white", backgroundColor: "red" };
      }
      return null;
    },
  };
};

export const formatEditor = (data: any) => {
  const strData = typeof data === "number" ? data.toString() : data;
  const spaceRemove = strData?.replace(/&nbsp;/g, " ");
  const ampRemove = spaceRemove?.replace(/&amp;/g, "&");
  const tagRemove = ampRemove?.replace(/<\/?[^>]+(>|$)/g, "");
  return tagRemove;
};

export const textFormatEditor = (fieldName: string) => {
  return {
    cellRenderer: (props: any) => {
      return renderNA(formatEditor(props?.data?.[fieldName]));
    },
    tooltipValueGetter: (props: any) => {
      return renderNA(formatEditor(props?.data?.[fieldName]));
    },
    filterValueGetter: (props: any) => {
      return renderNA(formatEditor(props?.data?.[fieldName]));
    },
    valueGetter: (props: any) => {
      return renderNA(formatEditor(props?.data?.[fieldName]));
    },
  };
};

export const importTextFormatEditor = (fieldName: string) => {
  return {
    cellRenderer: (props: any) => {
      return formatEditor(props?.data?.[fieldName]);
    },
    tooltipValueGetter: (props: any) => {
      return formatEditor(props?.data?.[fieldName]);
    },
    filterValueGetter: (props: any) => {
      return formatEditor(props?.data?.[fieldName]);
    },
    valueGetter: (props: any) => {
      return formatEditor(props?.data?.[fieldName]);
    },
  };
};
